<ng-container
    [ngTemplateOutlet]="hintData"
    [ngTemplateOutletContext]="{
        title: (titleTerm | translate),
        list: (listTerm | translate)
    }"></ng-container>

<ng-template #hintData let-title="title" let-list="list">
    <span class="sr-only">{{ title }} {{ stripHtml(list) }}</span>
    <div class="text-base" aria-hidden="true">
        <p>{{ title }}</p>
        <ul class="list-disc pl-6 leading-5" [innerHTML]="list"></ul>
    </div>
</ng-template>
